<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
<div [id]="'chart-container'+id" [ngStyle]="{ height: popUp ? '28em' : height ,padding:'4px'}"></div>
<!-- <svg height="0" width="0" style="position:absolute;">
    <defs>
        <pattern id="pattern3" width="10" height="10" patternUnits="userSpaceOnUse">
            <rect width="10" height="10" fill="white"></rect>
            <path d="M 2 2 L 4 3 M 4 2 L 2 5 M 7 7 L 9 8 M 9 7 L 7 10" stroke="#00FFFF" strokeWidth="10"></path>
        </pattern>
    </defs>
</svg> -->